import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const WarningIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 15, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 14) / 15}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.31542 9.39941C6.90636 9.39941 6.56348 9.7423 6.56348 10.1514C6.56348 10.5604 6.90636 10.9033 7.31542 10.9033C7.70943 10.9033 8.06735 10.5604 8.04931 10.1694C8.06735 9.73929 7.72748 9.39941 7.31542 9.39941Z"
        fill="currentColor"
      />
      <path
        d="M14.2756 12.0641C14.7478 11.249 14.7508 10.2775 14.2816 9.46541L9.57145 1.30837C9.10525 0.487257 8.26307 0 7.31864 0C6.3742 0 5.53203 0.490264 5.06583 1.30537L0.349666 9.47143C-0.119544 10.2925 -0.116536 11.2701 0.358689 12.0852C0.8279 12.8912 1.66706 13.3755 2.60548 13.3755H12.0137C12.9552 13.3755 13.8004 12.8852 14.2756 12.0641ZM13.2529 11.4746C12.9913 11.9258 12.5281 12.1934 12.0107 12.1934H2.60248C2.09116 12.1934 1.63097 11.9318 1.37531 11.4896C1.11664 11.0415 1.11364 10.5061 1.3723 10.0549L6.08847 1.89188C6.34413 1.44372 6.8013 1.17904 7.31864 1.17904C7.83297 1.17904 8.29315 1.44673 8.54881 1.89489L13.262 10.0579C13.5146 10.4971 13.5116 11.0264 13.2529 11.4746Z"
        fill="currentColor"
      />
      <path
        d="M7.12884 4.12084C6.77091 4.2231 6.54834 4.54794 6.54834 4.94196C6.56639 5.17957 6.58143 5.42019 6.59947 5.6578C6.6506 6.56314 6.70174 7.45043 6.75287 8.35576C6.77091 8.66255 7.00853 8.88513 7.31532 8.88513C7.62211 8.88513 7.86273 8.64751 7.87777 8.33771C7.87777 8.15123 7.87777 7.97979 7.89581 7.7903C7.9289 7.2098 7.96499 6.62931 7.99808 6.04881C8.01612 5.67284 8.04921 5.29687 8.06726 4.9209C8.06726 4.78555 8.04921 4.66524 7.99808 4.54493C7.84468 4.20806 7.48676 4.03662 7.12884 4.12084Z"
        fill="currentColor"
      />
    </svg>
  )
})

WarningIcon.displayName = 'WarningIcon'
